import React, { useState, useRef } from "react";

function ReactBeforeSlider({ firstImage, secondImage, className, delimiterColor = "#fff", delimiterIconStyles }) {
  const sliderRef = useRef(null);

  const [position, setPosition] = useState(50);

  const handleMouseMove = (event) => {
    const rect = sliderRef.current.getBoundingClientRect();
    const offsetX = event.clientX - rect.left;
    const percentage = (offsetX / rect.width) * 100;
    setPosition(Math.min(Math.max(percentage, 0), 100));
  };

  const handleTouchMove = (event) => {
    const rect = sliderRef.current.getBoundingClientRect();
    const offsetX = event.touches[0].clientX - rect.left;
    const percentage = (offsetX / rect.width) * 100;
    setPosition(Math.min(Math.max(percentage, 0), 100));
  };

  return (
    <div ref={sliderRef} className={`react-after-slider ${className || ""}`} onMouseMove={handleMouseMove} onTouchMove={handleTouchMove}>
      <div className="before" style={{ width: `${position}%` }}>
        <img src={firstImage.imageUrl} alt={firstImage.alt} />
      </div>
      <div className="after" style={{ width: `${100 - position}%` }}>
        <img src={secondImage.imageUrl} alt={secondImage.alt} />
      </div>
      <div
        className="delimiter"
        style={{
          left: `${position}%`,
        }}
      />
    </div>
  );
}

export default ReactBeforeSlider;
